<template>
  <footer>
    <div class="footer-row">
      <slot name="left-buttons"></slot>
      <span class="spacer"></span>
      <slot name="secondary"></slot>
      <button
        class="next-button"
        :disabled="disabled"
        data-test="next-button"
        @click="$emit('next-button-clicked')"
      >
        <span>{{ buttonText }}</span>
        <icon
          name="line-arrow-right"
          variant="white"
          class="next-button-icon"
        ></icon>
      </button>
    </div>
  </footer>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    requiresAgreement: {
      type: Boolean,
      default: false,
    },
    agreeChecked: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'Next',
    },
  },
  data() {
    return {
      agree: false,
    };
  },
  computed: {
    disabled() {
      return this.requiresAgreement && !this.agreeChecked;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-row {
  background-color: #006AAC;
  border-top: 2px solid white;
  color: white;
  font-size: 1.25rem;
  padding: 0.3125rem;
  display: flex;
  justify-content: space-between;

  .spacer {
    flex: 1;
  }
}

.next-button {
  background: transparent;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-left: 1rem;

  .next-button-icon {
    height: 1.25rem;
  }

  &:disabled {
    opacity: 0.5;
  }
}
</style>
